import React from 'react';
import { AuthWrapper, EmailInput, AuthFormHeader } from '@src/features/auth/components';
import { useVerifyEmailForm } from '@src/features/auth/hooks';
import { REQUIRED_VALIDATION_TEXT } from '@src/core/config';
import { ArcButton, ArcStack } from '@src/core/ui';

const VerifyEmailPage: React.FC = () => {
  const { register, formState: { errors }, onSubmit, isLoading } = useVerifyEmailForm();

  return (
    <AuthWrapper>
      <AuthFormHeader
        title='Reset password'
        subtitle="Enter your email and we'll send you a reset link"
      />
      <ArcStack
        mt={4}
        spacing={5}
        component='form'
        alignItems='center'
        onSubmit={onSubmit}>
        <EmailInput
          register={register('email', { required: REQUIRED_VALIDATION_TEXT })}
          error={errors.email}
        />
        <ArcButton.brand
          type='submit'
          sx={{ width: 300 }}
          isLoading={isLoading}>
          Send reset link
        </ArcButton.brand>
      </ArcStack>
    </AuthWrapper>
  );
};

export default VerifyEmailPage;